const strings = {
    hi: '✨ Hi, I\'m Adriana! ✨',
    job_description_target: '📱Senior Android Engineer at Target🎯',
    job_description_mcdonalds: '📱Android Engineer II at McDonald\'s🍟',
    self_description: 'Making apps, sometimes websites. Fan of cool designs.',
    button_mpls_app: 'Skyway Map Minneapolis',
    button_st_paul_app: 'Skyway Map St. Paul',
    button_ttu_site: 'TTUCovid19.com',
    button_personal_site: 'adriana.dev',
    coffee_intro: 'Has my work helped you?',
    coffee_text: 'Buy me a coffee!'
}

export default strings;